var SpriteSymbol = require("svg-baker-runtime/browser-symbol");
var sprite = require("svg-sprite-loader/runtime/browser-sprite.build");
var symbol = new SpriteSymbol({
  "id": "icons-close",
  "use": "icons-close-usage",
  "viewBox": "0 0 64 64",
  "content": "<symbol viewBox=\"0 0 64 64\" id=\"icons-close\">\n<style type=\"text/css\">\n\t#icons-close .st0{fill:#1C1C1C;}\n\t#icons-close .st1{fill:#E80000;}\n</style>\n<path class=\"st0\" d=\"M38.3,32L53,46.7L46.7,53L32,38.3L17.3,53L11,46.7L25.7,32L11,17.3l6.3-6.3L32,25.7L46.7,11l6.3,6.3L38.3,32z\" />\n</symbol>"
});
var result = sprite.add(symbol);
module.exports = symbol


//////////////////
// WEBPACK FOOTER
// ./src/components/icon/icons-close.icon
// module id = 280
// module chunks = 35783957827783